// TelcoTrack — mark a pill group to sit centered on the page-header title row.

import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { PageHeaderPillsService } from '../../core/services/page-header-pills.service';

@Directive({
  selector: '[ttPageHeaderPills]',
})
export class PageHeaderPillsDirective implements AfterViewInit, OnDestroy {
  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly pillsSlot: PageHeaderPillsService,
  ) {}

  ngAfterViewInit(): void {
    this.pillsSlot.attach(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.pillsSlot.detach(this.host.nativeElement);
  }
}
